import React from 'react';
import CardSkeleton from './Card';
import Shimmer from '../Shimmer';
import * as styles from './style.module.css';

const DashboardSkeleton = () => {
  return (
    <div className={styles.dashboardSkeleton} data-testid="dashboard-skeleton">
      <div className={styles.shadowWrapper}>
        <Shimmer width="100%" height="40px" />
      </div>

      <CardSkeleton />

      <div className={styles.singleRow}>
        <div className={styles.singleRow}>
          <CardSkeleton size="large" />
          <CardSkeleton size="large" />
        </div>
        <div className={styles.singleRow}>
          <CardSkeleton size="large" />
        </div>
      </div>

      <CardSkeleton />
      <CardSkeleton size="large" />
      <CardSkeleton size="large" />

      <div className={styles.singleRow}>
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  );
};

export default DashboardSkeleton;